import { styled } from "common/components";

export const StyledHeaders = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  borderBottom: `2px solid ${theme.palette.divider}`,
}));
